import React from "react";
import PaginationControls from "../../../../utils/PaginationControls";
import { getInitials, getRandomColor } from "../../../../utils/UserCustomDisplay";

const HumanReviewerAllocation = ({
    team,
    reviewers,
    totals,
    assignedDisplay,
    rangeError,
    errors,
    hasErrors,

    excludeUserIds = [],
    isLoadingTeam = false,


    page,
    totalPages,
    pageSize,

    searchInput,
    onSearchInputChange,
    onSearchKeyPress,
    onSearch,

    onPrevPage,
    onNextPage,
    onPageSizeChange,

    onToggleReviewer,
    onUpdateRange,
    onRemoveReviewer,
    onClearAll,
    onAutoAssign,
    onRefreshCounts,
    isRefreshingCounts = false,
}) => {
    return (
        <div className="row mt-3 slr-alloc-root">
            {/* left: Team list */}
            <div className="col-lg-5 col-md-5">
                <div className="ev-card-4 ev-card-8 ev-radius-small pt-2 pb-2 slr-alloc-team-panel">
                    {/* Search header */}
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <div className="col-5 position-relative">
                            <input
                                type="text"
                                className="form-control search-input ms-0"
                                placeholder="Search users"
                                value={searchInput}
                                onChange={onSearchInputChange}
                                onKeyPress={onSearchKeyPress}
                            />
                            <button type="button" className="ev-btn-lightblue-fill-round search-bar-button" onClick={onSearch}>
                                <i className="bi bi-search"></i>
                            </button>
                        </div>

                        <div className="col-7 d-flex justify-content-end align-items-center">
                            <div className="d-flex align-items-center">
                                <button type="button" className="ev-btn-light-fill ev-btn-xsmall" disabled={page === 1} onClick={onPrevPage}>
                                    <i className="bi bi-chevron-left"></i>
                                </button>

                                <span className="ev-xsmall-p-dark ms-1">
                                    Page {page}/{totalPages}
                                </span>

                                <button
                                    type="button"
                                    className="ev-btn-light-fill ev-btn-xsmall ms-1"
                                    disabled={page >= totalPages}
                                    onClick={onNextPage}
                                >
                                    <i className="bi bi-chevron-right"></i>
                                </button>
                            </div>

                            <div className="d-flex align-items-center ms-2">
                                <PaginationControls initialSize={pageSize} onSizeChange={onPageSizeChange} />
                            </div>
                        </div>
                    </div>

                    {/* list */}
                    <div className="scrollable-element slr-alloc-team-list">
                        {isLoadingTeam ? (
                            <div className="d-flex justify-content-center align-items-center py-4">
                                <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <span className="ev-small-p-dark">Loading team members...</span>
                            </div>
                        ) : team.length === 0 ? (
                            <p className="ev-small-p-dark m-2">No team members found.</p>
                        ) : (
                            team.map((m) => {
                                const uid = m.user_id ?? m.uid ?? m.id;
                                const blockedByOtherSet = excludeUserIds.includes(uid);
                                const noPapersAvailable = !(totals?.overall > 0);
                                const disabled = blockedByOtherSet || noPapersAvailable;

                                let tooltip = "";
                                if (blockedByOtherSet) {
                                    tooltip = "This user is already assigned in the other set";
                                } else if (noPapersAvailable) {
                                    tooltip = "No papers available";
                                }

                                return (
                                    <div key={uid} className="d-flex align-items-center justify-content-between ev-radius-small ev-padding-small py-1">
                                        <div className="d-flex align-items-center gap-2">
                                            <div
                                                className="user-circle user-circle--small d-flex align-items-center justify-content-center"
                                                style={{ backgroundColor: getRandomColor(m.email) }}
                                            >
                                                {getInitials(m.email)}
                                            </div>
                                            <p className="mb-0 ev-reg-p-dark">{m.email}</p>
                                        </div>

                                        <button
                                            className={`ev-btn-blue-outline-round ev-bold-reg ev-btn-small avatar-tooltip-bottom ${disabled ? "disabled opacity-50" : ""}`}
                                            style={disabled ? { cursor: "not-allowed" } : undefined}
                                            onClick={() => onToggleReviewer(m)}
                                            disabled={disabled}
                                            data-tooltip={tooltip}
                                        >
                                            Add Reviewer
                                        </button>
                                    </div>
                                );
                            })
                        )}
                    </div>
                </div>
            </div>

            {/* right: reviewers */}
            <div className="col-lg-7 col-md-7">
                <div className="slr-alloc-right">
                    <div className="d-flex align-items-center">
                        <p className="ev-med-p-blue ev-bold-med mb-0 ev-bold-reg me-2">
                            Reviewers ({reviewers.length})
                        </p>
                        <span className="ev-alert-card-warning ev-btn-reg ev-fs-11 ev-radius-large ev-bold-med">
                            <p className="mb-0 ev-bold-med">{assignedDisplay}</p>
                        </span>

                        {typeof onRefreshCounts === "function" ? (
                            <button
                                type="button"
                                className="ev-btn-lightblue-fill-round ev-bold-med ms-2 ev-btn-small ev-radius-reg avatar-tooltip"
                                onClick={onRefreshCounts}
                                disabled={isRefreshingCounts}
                                data-tooltip="fetch latest paper count"
                            >
                                <i className={`bi bi-arrow-repeat ${isRefreshingCounts ? "ev-rotate" : ""}`}></i>

                            </button>

                        ) : null}
                    </div>


                    <div className="text-end mb-2">
                        <button className="ev-btn-blue-outline-round ev-bold-med ev-btn-small me-2" onClick={onClearAll} disabled={!reviewers.length}>
                            Clear All
                        </button>
                        <button
                            className="ev-btn-lightblue-fill-round ev-bold-med ev-btn-small"
                            onClick={onAutoAssign}
                            disabled={!reviewers.length || !(totals.overall > 0)}
                        >
                            Auto Assign
                        </button>
                    </div>

                    {rangeError ? (
                        <div className="d-inline-flex mb-2">
                            <span className="ev-message-card3 ev-fs-11 mb-0">{rangeError}</span>
                        </div>
                    ) : null}

                    <div className="row ev-small-p-blue ev-bold-reg mb-1">
                        <div className="ev-reg-p-blue ev-bold-med col-6">Reviewer</div>
                        <div className="ev-reg-p-blue ev-bold-med col-4">Allocation Range</div>
                        <div className="ev-reg-p-blue ev-bold-med col-2 text-end">Actions</div>
                    </div>

                    <div className="scrollable-element slr-alloc-reviewer-list pb-3">
                        <table className="table-custom1 overflow-hidden w-100 table-sm align-middle">
                            <tbody>
                                {reviewers.length === 0 ? (
                                    <tr>
                                        <td colSpan="3" className="text-center">
                                            <p className="ev-small-p-dark mt-2 mb-2 py-1">No reviewers added yet.</p>
                                        </td>
                                    </tr>
                                ) : (() => {
                                    return reviewers.map((r) => {
                                        return (
                                            <tr key={r.rowId}>
                                                <td className="align-middle py-2 px-2 w-50 pe-5">
                                                    <div className="formField3 ev-reg-p-blue py-1 ev-radius-small">
                                                        {r.email}
                                                    </div>
                                                </td>

                                                <td className="align-middle py-1 px-2 w-35">
                                                    <div className="d-flex flex-column gap-1">
                                                        <div className="d-flex gap-2">
                                                            <input
                                                                className="formField3 w-30 ev-message-card6 py-1 ev-radius-xsmall "
                                                                type="text"
                                                                placeholder="Start"
                                                                value={r.start}
                                                                onChange={(e) => onUpdateRange(r.rowId, "start", e.target.value)}
                                                            />
                                                            <input
                                                                className="formField3 w-30 ev-message-card6 py-1 ev-radius-xsmall"
                                                                type="text"
                                                                placeholder="End"
                                                                value={r.end}
                                                                onChange={(e) => onUpdateRange(r.rowId, "end", e.target.value)}
                                                            />
                                                        </div>

                                                        {errors?.[r.rowId] ? (
                                                            <div className="d-inline-flex mt-1">
                                                                <span className="ev-message-card3 ev-fs-11 mb-0">{errors[r.rowId]}</span>
                                                            </div>
                                                        ) : null}
                                                    </div>
                                                </td>

                                                <td className="align-middle py-1 px-2 w-15 text-end">
                                                    <div className="btn-group" role="group">
                                                        <button
                                                            className="btn ev-btn-red-fill-round ev-btn-med ev-radius-xsmall pe-2 ps-2 avatar-tooltip"
                                                            onClick={() => onRemoveReviewer(r.rowId)}
                                                            data-tooltip="Remove Reviewer"
                                                        >
                                                            <i className="bi bi-trash"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        );
                                    });
                                })()}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HumanReviewerAllocation;